import React from 'react'

export const ShuttleSchedule: React.FC = () => {
  return (
    <div
      id="shuttle-schedule"
      className="bg-white rounded-lg shadow-lg p-4 md:p-6 mb-8"
    >
      <h3 className="sticky top-0 z-10 bg-white text-xl md:text-2xl font-serif text-[#3C2416] mb-4 py-2 -mx-4 px-4 md:static md:mx-0 md:px-0 md:py-0">
        Shuttle Schedule
      </h3>
      <div className="prose-text">
        <p className="text-[#3C2416] mb-4">
          <strong>July 20 Arrivals / July 25 Departures:</strong>
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h4 className="text-lg font-medium text-[#A6410A] mb-2">
              Sunday Arrivals
            </h4>
            <div className="text-[#3C2416]">
              <p className="mb-2">• 1 bus at 2:45 PM</p>
              <p className="mb-2">• 1 bus at 5:45 PM</p>
              <p className="mb-2">• 1 large van at 10:30 PM</p>
              <p className="mb-2">• 1 large van at 12:30 AM</p>
              <p className="text-sm mt-3">
                Pick-ups at BTV → Resort (approx. 55 min drive). The vehicles
                will also drop folks off at the Outbound Stowe, AWOL Stowe, and
                Bluebird Cady Hill Lodge.
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-medium text-[#A6410A] mb-2">
              Friday Departures
            </h4>
            <div className="text-[#3C2416]">
              <p className="mb-2">• 1 large van at 8:00 AM</p>
              <p className="mb-2">• 1 large van at 8:15 AM</p>
              <p className="mb-2">• 1 bus at 1:00 PM</p>
              <p className="mb-2">• 1 bus at 3:00 PM</p>
              <p className="text-sm mt-3">
                From resort → BTV (approx. 55 min drive).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
